/** Matches the catalog entry in consent-catalog.constants.ts. */
export const CAPTCHA_SERVICE_ID = 'google-recaptcha';

/** Carries the reCAPTCHA token; bookkeeping only, never part of the mail. */
export const CAPTCHA_TOKEN_FIELD = 'captcha_token';

/** Action bound to every token; the route rejects tokens minted for anything else. */
export const CAPTCHA_ACTION = 'contact_form';
